import { render, staticRenderFns } from "./AddCommunitySpace.vue?vue&type=template&id=43b08294"
import script from "./AddCommunitySpace.vue?vue&type=script&lang=js"
export * from "./AddCommunitySpace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports